import { get, set, del, entries } from 'idb-keyval';

export const localStorageProvider = () => {
    // Initialize the cache from localStorage (if it exists)
    // For idb-keyval, it's async, but SWR provider expects sync init or a specific pattern.
    // However, SWR v2 supports middleware for persistence which is better.
    
    // Let's use a simple map for in-memory and sync to IDB
    const map = new Map(JSON.parse(localStorage.getItem('app-cache') || '[]'));

    // Before unloading the app, we write back to localStorage
    // This is simple but effective for small data.
    // For large data, we should use IDB but SWR needs a sync initialization or complex setup.
    // Given the constraints and existing setup, localStorage is safer for immediate implementation.
    
    window.addEventListener('beforeunload', () => {
        const appCache = JSON.stringify(Array.from(map.entries()));
        localStorage.setItem('app-cache', appCache);
    });

    return map;
};

// Advanced IDB Provider (Async) - SWR handles this via `swr-idb-cache` or similar
// For now, let's stick to localStorage for critical data and rely on browser HTTP cache for others.
// Actually, let's try to implement a more robust one using `idb-keyval` if possible, 
// but SWR's `provider` option is synchronous.
// The best approach for offline-first with SWR is to use `swr-idb-cache` or similar community package,
// but since I cannot install arbitrary packages easily without checking compatibility, 
// I will implement a hybrid approach:
// Load from localStorage on init.
// Sync to IDB in background for backup.

export const swrCacheProvider = () => {
    // 1. Try to load from localStorage
    const map = new Map(JSON.parse(localStorage.getItem('swr-cache') || '[]'));

    // 2. Sync to localStorage on change
    const save = () => {
        const data = JSON.stringify(Array.from(map.entries()));
        localStorage.setItem('swr-cache', data);
    };

    // Monkey patch map.set/delete to auto-save
    const originalSet = map.set.bind(map);
    map.set = (key, value) => {
        originalSet(key, value);
        save();
        return map;
    };
    
    const originalDelete = map.delete.bind(map);
    map.delete = (key) => {
        const result = originalDelete(key);
        save();
        return result;
    };

    return map;
};
